module.exports = __webpack_public_path__ + "img/answer-ceramic.ce5e044a.png";